import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavigationStart, Router } from "@angular/router";
export let RequestStatusService = class RequestStatusService {
    router;
    busyRequests;
    countBusyRequests = 0;
    requestBusySubject = new BehaviorSubject(false);
    $requestBusy = this.requestBusySubject.asObservable();
    constructor(router) {
        this.router = router;
        this.busyRequests = new Set();
        this.clearRequestsOnRouteChange();
    }
    clearBusyRequestCounter() {
        this.countBusyRequests = 0;
    }
    showBusySpinner(key) {
        this.countBusyRequests++;
        // console.log("show ",key, this.countBusyRequests);
        this.updateSomeRequestBusy();
        if (!this.busyRequests.has(key)) {
            this.busyRequests.add(key);
        }
    }
    removeBusySpinner(key) {
        this.countBusyRequests--;
        // console.log("remove ",key, this.countBusyRequests);
        this.busyRequests.delete(key);
        this.updateSomeRequestBusy();
    }
    updateSomeRequestBusy() {
        this.requestBusySubject.next(this.countBusyRequests > 0);
    }
    clearRequestsOnRouteChange() {
        this.router.events.subscribe(change => {
            if (change instanceof NavigationStart) {
                if (this.router.url !== change.url) {
                    this.busyRequests = new Set();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: Router }
    ];
};
RequestStatusService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RequestStatusService);
